
module.exports = process.env.JADE_COV
  ? require('./lib-cov/jade')
  : require('./lib/jade');


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/~/jade/index.js
 ** module id = 103
 ** module chunks = 1
 **/